import React from "react";

export const Button = ({
  href,
  disabled,
  outline = false,
  className = '',
  title,
  illustrated = false,
  flat = false,
  children = <></>,
  ...rest
}) => {
  const classes = `tw-outline-none tw-inline-flex tw-gap-2 md:tw-gap-4 tw-whitespace-nowrap tw-items-center tw-justify-center
        ${outline ? 'tw-bg-transparent tw-border-secondary tw-text-secondary ' : 'tw-border-secondary tw-bg-secondary tw-text-white '}
        ${!flat ? 'tw-px-5 tw-py-3 tw-rounded-full ' : ''}
        ${disabled ? 'tw-opacity-25 tw-cursor-not-allowed ' : 'hover:tw-opacity-90 '}
        ${className}`;

  const Content = (
    <>
      {disabled ? 'loading' : (title ?? children)}
      {illustrated && (
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M9.9974 18.3346C14.5998 18.3346 18.3307 14.6037 18.3307 10.0013C18.3307 5.39893 14.5998 1.66797 9.9974 1.66797C5.39502 1.66797 1.66406 5.39893 1.66406 10.0013C1.66406 14.6037 5.39502 18.3346 9.9974 18.3346Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeMiterlimit="10"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M8.95312 12.9419L11.8865 10.0003L8.95312 7.05859"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      )}
    </>
  );

  const style = {
    border: !flat ? '1px solid #6D60F6' : 'none',
    fontFamily: 'Satoshi-Medium',
    fontWeight: 500,
  }

  if (href) {
    return (
      <a style={style} className={classes} href={href} {...rest}>
        {Content}
      </a>
    );
  }

  return (
    <button style={style} className={classes} disabled={disabled} {...rest}>
      {Content}
    </button>
  );
};
